/**
 * Created by pavelkozhin on 28/07/16.
 */

define([
    'library/fcse-compatibility/object',
    'library/fcse-request/multiRequestHandler',
    'library/fcse-util/url'
], function(Object, MultiRequestHandler, Url) {

    var MultiRequestHandlerExtended = function(options) {
        MultiRequestHandler.apply(this, arguments);
    };

    MultiRequestHandlerExtended.prototype = $.extend(Object.create(MultiRequestHandler.prototype), {

        send: function (route, queryParams, routeParams, options) {
            var url = new Url();
            var isHotelSearch = url.query.searchField == 'search-widget' || url.query.searchField == 'searchmask-search-widget';

            if (isHotelSearch && route.indexOf('accordion') > 0) {
                queryParams.hotelName = url.query.hotelName;
            }
            MultiRequestHandler.prototype.send.call(this, route, queryParams, routeParams, options);
        }
    });

    return MultiRequestHandlerExtended;
});


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/request/multiRequestHandlerExtended.js